import { render, staticRenderFns } from "./bulkOrderItemList.vue?vue&type=template&id=62a6e2da&"
import script from "./bulkOrderItemList.vue?vue&type=script&lang=js&"
export * from "./bulkOrderItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports